import React, { useState, useEffect } from "react";

interface CountdownProps {
  running: boolean;
  timerStart: number;
}

export const CountdownTimer: React.FC<CountdownProps> = (
  props: CountdownProps,
) => {
  const [timer, setTimer] = useState(props.timerStart);

  useEffect(() => {
    if (!props.running) {
      return;
    }
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [props.running]);

  return <span>{timer}</span>;
};
